const baseurl = process.env.REACT_APP_OBC_BASEURL;

const baseurl_proxy = process.env.REACT_APP_OBC_BASEURL_PROXY;

let oauthServerUrl_var = "";
let UserinfoUrl_var = "";

// export const oauthServerUrl = baseurl_proxy + "/as/token.oauth2";
// export const UserinfoUrl = baseurl_proxy + "/idp/userinfo.openid";
if (
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1"
) {
  oauthServerUrl_var = baseurl_proxy + "/as/token.oauth2";
  UserinfoUrl_var = baseurl_proxy + "/idp/userinfo.openid";
} else {
  oauthServerUrl_var = baseurl + "/as/token.oauth2";
  UserinfoUrl_var = baseurl + "/idp/userinfo.openid";
}

export const oauthServerUrl = oauthServerUrl_var;

export const UserinfoUrl = UserinfoUrl_var;

export const authorizationUrl = baseurl + "/as/authorization.oauth2";

export const clientId = process.env.REACT_APP_OBC_CLIENTID;

export const obcbasic = process.env.REACT_APP_OBC_CODE;

export const redirectUri = process.env.REACT_APP_OBC_REDIRECTURI;

export const LogoutUrl = baseurl + "/idp/startSLO.ping";

export const revokeTokenUrl = baseurl + "/as/revoke_token.oauth2";

export const corsmode = "cors";

export const responseTypeCode = "code";

export const app_id = "DPLP";

export const accessdenied =
  "https://login.mercedes-benz.com/error/access-denied";
// "https://login-int.mercedes-benz.com/error/access-denied";

// OpenID Connect Discovery baseURL/.well-known/openid-configuration
// OAuth 2.0 Token Introspection baseURL/as/introspect.oauth2

export const grant_type_ac = "authorization_code";
export const grant_type_rt = "refresh_token";

export const scope =
  "openid iamat.brand.mb organizational_data add_org_data profile email authorization_group entitlement_group scoped_entitlement offline_access";

export const apikey = process.env.REACT_APP_OBC_APIKEY;

export const apikey_header = process.env.REACT_APP_OBC_APIKEY_HEADER;

export const backend_url = process.env.REACT_APP_OBC_BACKEND;

export const VlnState = process.env.REACT_APP_VLNSTATE;
